import mixpanel from 'mixpanel-browser';
import { ENV } from '@/config/env';

export const mixpanelInit = () => {
  mixpanel.init(ENV.MIXPANEL.APP_KEY, {
    debug: false,
    track_pageview: true,
    track_marketing: false,
    skip_first_touch_marketing: true,
  });
};

export const mixpanelTrackEvent = (name, data) => {
  if (data) {
    mixpanel.track(name, data);
  } else {
    mixpanel.track(name);
  }
};
